export const COMMON_T = {
  fr: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    close: 'Fermer',
    delete: 'Supprimer',
    edit: 'Modifier',
    refresh: 'Actualiser',
    loading: 'Chargement…',
    back: 'Retour',
    view_all: 'Voir tout',
    access: 'Accéder',
    manage: 'Gérer',
    start: 'Commencer',
    collapse: 'Réduire',
    expand: 'Afficher',
    no_results: 'Aucun résultat',
    page_loading: 'Chargement de la page',
    guest: 'Invité',
    today: (time) => `Auj. ${time}`,
    yesterday: (time) => `Hier ${time}`,
    created: 'Créé',
    modified: 'Modifié',
    deleted: 'Supprimé',
    active: 'Actif',
    inactive: 'Inactif',
    expired: 'Expiré',
    prev: 'Précédent',
    next: 'Suivant',
    page_of: (current, total) => `Page ${current} / ${total}`,
    fulfil_fulfilled: 'Livrée',
    fulfil_unfulfilled: 'Non expédiée',
    fulfil_partial: 'Partiellement livrée',
    status_fulfilled: 'Traitée',
    status_unfulfilled: 'Pas traitée',
    status_partial: 'Partiellement traitée',
    status_processing: 'En cours',
    status_cancelled: 'Annulée',
    pay_paid: 'Payé',
    pay_unpaid: 'Non payé',
    pay_partial: 'Partiellement payé',
    pay_refunded: 'Remboursé',
    contact_none: 'En attente',
    contact_confirmed: 'Confirmée',
    contact_refused: 'Refusée',
    yes: 'Oui',
    no: 'Non',
    configure: 'Configurer',
    connect: 'Connecter',
    buy: 'Acheter',
    open: 'Ouvrir',
    change: 'Changer',
    add: 'Ajouter',
    choose: 'Choisir',
    per_page: 'Par page :',
    goto: 'Aller à :',
    ok: 'OK',
    toggle: 'Basculer',
    view: 'Voir',
    total_label: (n) => `Total : ${n}`,
    modify_aria: (label) => `Modifier ${label}`,
  },
  en: {
    save: 'Save',
    cancel: 'Cancel',
    close: 'Close',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    loading: 'Loading…',
    back: 'Back',
    view_all: 'View all',
    access: 'Open',
    manage: 'Manage',
    start: 'Get started',
    collapse: 'Collapse',
    expand: 'Show',
    no_results: 'No results',
    page_loading: 'Loading page',
    guest: 'Guest',
    today: (time) => `Today ${time}`,
    yesterday: (time) => `Yesterday ${time}`,
    created: 'Created',
    modified: 'Modified',
    deleted: 'Deleted',
    active: 'Active',
    inactive: 'Inactive',
    expired: 'Expired',
    prev: 'Previous',
    next: 'Next',
    page_of: (current, total) => `Page ${current} / ${total}`,
    fulfil_fulfilled: 'Delivered',
    fulfil_unfulfilled: 'Not shipped',
    fulfil_partial: 'Partially delivered',
    status_fulfilled: 'Processed',
    status_unfulfilled: 'Not processed',
    status_partial: 'Partially processed',
    status_processing: 'Processing',
    status_cancelled: 'Cancelled',
    pay_paid: 'Paid',
    pay_unpaid: 'Unpaid',
    pay_partial: 'Partially paid',
    pay_refunded: 'Refunded',
    contact_none: 'Pending',
    contact_confirmed: 'Confirmed',
    contact_refused: 'Declined',
    yes: 'Yes',
    no: 'No',
    configure: 'Configure',
    connect: 'Connect',
    buy: 'Buy',
    open: 'Open',
    change: 'Change',
    add: 'Add',
    choose: 'Choose',
    per_page: 'Per page:',
    goto: 'Go to:',
    ok: 'OK',
    toggle: 'Toggle',
    view: 'View',
    total_label: (n) => `Total: ${n}`,
    modify_aria: (label) => `Edit ${label}`,
  },
  ar: {
    save: 'حفظ',
    cancel: 'إلغاء',
    close: 'إغلاق',
    delete: 'حذف',
    edit: 'تعديل',
    refresh: 'تحديث',
    loading: 'جار التحميل…',
    back: 'رجوع',
    view_all: 'عرض الكل',
    access: 'فتح',
    manage: 'إدارة',
    start: 'ابدأ',
    collapse: 'طي',
    expand: 'عرض',
    no_results: 'لا توجد نتائج',
    page_loading: 'جار تحميل الصفحة',
    guest: 'زائر',
    today: (time) => `اليوم ${time}`,
    yesterday: (time) => `أمس ${time}`,
    created: 'تم الإنشاء',
    modified: 'تم التعديل',
    deleted: 'تم الحذف',
    active: 'نشط',
    inactive: 'غير نشط',
    expired: 'منتهي',
    prev: 'السابق',
    next: 'التالي',
    page_of: (current, total) => `الصفحة ${current} / ${total}`,
    fulfil_fulfilled: 'تم التسليم',
    fulfil_unfulfilled: 'لم يُشحن',
    fulfil_partial: 'تسليم جزئي',
    status_fulfilled: 'تمت المعالجة',
    status_unfulfilled: 'لم تُعالج',
    status_partial: 'معالجة جزئية',
    status_processing: 'قيد المعالجة',
    status_cancelled: 'ملغاة',
    pay_paid: 'مدفوع',
    pay_unpaid: 'غير مدفوع',
    pay_partial: 'مدفوع جزئياً',
    pay_refunded: 'مسترد',
    contact_none: 'قيد الانتظار',
    contact_confirmed: 'مؤكدة',
    contact_refused: 'مرفوضة',
    yes: 'نعم',
    no: 'لا',
    configure: 'إعداد',
    connect: 'ربط',
    buy: 'شراء',
    open: 'فتح',
    change: 'تغيير',
    add: 'إضافة',
    choose: 'اختيار',
    per_page: 'لكل صفحة:',
    goto: 'الانتقال إلى:',
    ok: 'موافق',
    toggle: 'تبديل',
    view: 'عرض',
    total_label: (n) => `الإجمالي: ${n}`,
    modify_aria: (label) => `تعديل ${label}`,
  },
};

export function fulfilLabel(t, key) {
  const map = {
    FULFILLED: t.fulfil_fulfilled,
    UNFULFILLED: t.fulfil_unfulfilled,
    PARTIALLY_FULFILLED: t.fulfil_partial,
    PARTIAL: t.fulfil_partial,
  };
  return map[key] || key;
}

export function statusLabel(t, key) {
  const map = {
    FULFILLED: t.status_fulfilled,
    UNFULFILLED: t.status_unfulfilled,
    PARTIALLY_FULFILLED: t.status_partial,
    PARTIAL: t.status_partial,
    PROCESSING: t.status_processing,
    CANCELLED: t.status_cancelled,
  };
  return map[key] || key;
}

export function payLabel(t, key) {
  const map = {
    PAID: t.pay_paid,
    UNPAID: t.pay_unpaid,
    PARTIALLY_PAID: t.pay_partial,
    PARTIAL: t.pay_partial,
    REFUNDED: t.pay_refunded,
  };
  return map[key] || key;
}

export function contactLabel(t, key) {
  const map = {
    NONE: t.contact_none,
    CONFIRMED: t.contact_confirmed,
    REFUSED: t.contact_refused,
  };
  return map[key] || key;
}
